import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ClientService {

	constructor(
		private http: HttpClient
	) { }

	// Creates a client
	createClient(name: string, customerId: string, companyId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('name', name);
		params = params.set('customerId', customerId);
		params = params.set('companyId', companyId);
		params = params.set('esignType', 'adobe');

		return this.http.post<any>(`${environment.serviceUrl}/client`, '', { headers, params });
	}

	// Looks up a client by customer id
	getClientByCustomerId(customerId: string) {
		let params = new HttpParams();
		params = params.set('customerId', customerId);

		return this.http.get<any>(`${environment.serviceUrl}/client`, { params });
	}

	// Looks up client detail procore configuration by company id
	getClientDetailProcoreByCompanyId(companyId: number, projectId: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);

		return this.http.get<any>(`${environment.serviceUrl}/client/procore`, { params });
	}

	updateClientDetailProcore(clientDetailProcore: any) {
		const params = new HttpParams();

		return this.http.put<any>(`${environment.serviceUrl}/client/procore`, clientDetailProcore, { params });
	}

	// Looks up a client stripe customer id and creates a new one if needed
	createClientCustomerId(email: string, name: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'text/plain');

		let params = new HttpParams();
		params = params.set('email', email);
		params = params.set('name', name);

		return this.http.post(`${environment.serviceUrl}/client/customerId`, '', { headers, params, responseType: 'text' });
	}

	updateProcoreProjectConfigs(configs: any, clientId: number, projectId: string) {
		let params = new HttpParams();
		params = params.set('clientId', clientId);
		params = params.set('projectId', projectId);

		const requestUrl = `${environment.serviceUrl}/client/project-configs`;

		return this.http.post<any>(requestUrl, configs, { params });
	}

	getSignaturesByProcoreContext(companyId: number, context: string, username: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('context', context);
		params = params.set('username', username);
		params = params.set('applicationType', "AAS for Procore");

		const requestUrl = `${environment.serviceUrl}/client/signatures`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}
}
